export default "__VITE_ASSET__DEd3ZLBK__"